module.exports = __webpack_public_path__ + "static/media/Ayomide-Kuye.79b54ccb.png";